import React from 'react';
import Redirect from 'react-router-dom/Redirect';
import hoistStatics from 'hoist-non-react-statics';

export default (resolve, options) => Component => {
  const { memory = false } = options || {};
  if (!resolve || typeof resolve !== 'function') {
    throw new Error('redirect resolve is not a function');
  }
  const C = props => {
    const redirect = resolve(props);
    // Return to destination if memory feature is enabled.
    if (memory && typeof localStorage !== 'undefined') {
      const destination = localStorage.getItem('destination');
      if (destination) {
        localStorage.removeItem('destination');
        return <Redirect to={destination} />;
      }
    }
    if (redirect) {
      // Remember where we came from if memory feature is enabled.
      if (memory && typeof localStorage !== 'undefined') {
        const { pathname: destination } = location;
        localStorage.setItem('destination', destination);
      }
      return <Redirect to={redirect} />;
    }
    return <Component {...props} />;
  };
  C.displayName = `withRedirect(${Component.displayName || Component.name})`;
  return hoistStatics(C, Component);
};



// WEBPACK FOOTER //
// ./src/helpers/withRedirect.js